import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useState } from "react";
import { modalDeleteIgnoredDivergence } from "../../atoms/atom";
import { ComparationService } from "../../services/ComparationService";
import { getDivergenceFieldLabel, IgnoredDivergence } from "../../types/IgnoredDivergence";
import { useAlert } from "../contextProviders/AlertProvider";

interface Props {
	ignored: IgnoredDivergence | undefined;
	onDeleted: () => void;
}

const DeleteIgnoredDivergenceModal: FC<Props> = (props: Props) => {
	const [open, setOpen] = useAtom(modalDeleteIgnoredDivergence);
	const [loading, setLoading] = useState(false);
	const { showAlert, showError } = useAlert();

	const remove = async () => {
		if (!props.ignored) {
			return;
		}
		setLoading(true);
		try {
			const response = await new ComparationService().deleteIgnoredDivergence(props.ignored.id);
			if (response.status === 200) {
				showAlert('Divergência ignorada removida com sucesso');
				setOpen(false);
				props.onDeleted();
			}
		} catch (error) {
			showError();
		} finally {
			setLoading(false);
		}
	};

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			id="modal-delete-ignored-divergence"
		>
			<DialogTitle>Remover divergência ignorada</DialogTitle>
			<DialogContent>
				<Typography>
					Você confirma a remoção da regra do campo {getDivergenceFieldLabel(props.ignored?.field || '')},
					que ignora o valor "{props.ignored?.sggValue || '-'}" no SGG
					contra "{props.ignored?.esocialValue || '-'}" no eSocial?
				</Typography>
				<Typography sx={{marginTop: "1vh"}}>
					A partir da próxima execução esse campo voltará a ser apontado como divergente.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setOpen(false)}>
					Cancelar
				</Button>
				<Button
					color="error"
					variant="contained"
					onClick={() => remove()}
					disabled={loading}
				>
					{loading
						? <CircularProgress sx={{color: "#48a7dbff"}} size={'20px'}/>
						: "Remover"
					}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default DeleteIgnoredDivergenceModal;